import { render, staticRenderFns } from "./waiguan_add.vue?vue&type=template&id=5c3e865c"
import script from "./waiguan_add.vue?vue&type=script&lang=js"
export * from "./waiguan_add.vue?vue&type=script&lang=js"
import style0 from "./waiguan_add.vue?vue&type=style&index=0&id=5c3e865c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports